<template>
  <el-popover
    placement="bottom"
    width="400"
    trigger="click">
    <div class="row">
      <div class="first">
        <div class="flex" @click="getItem(item)" v-for="item in option" :key="item.value">
          <el-checkbox v-model="item.select" @change="toggleItem(item,$event)">{{item.label}}</el-checkbox>
          <i class="el-icon el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="second" v-if="secondData.length !== 0">
        <div class="flex" v-for="item in secondData" :key="item.value" @click="changeChild(item)">
          <el-checkbox v-model="item.select">{{item.label}}</el-checkbox>
        </div>
      </div>
    </div>
    <span class="el-dropdown-link" :class="border && 'border'" slot="reference">
      {{getTitle}}<i class="el-icon-arrow-down el-icon--right"></i>
    </span>
  </el-popover>
</template>
<script>
  import _ from 'lodash'
  export default {
    props: {
      value: null,
      options: {
        default: () => []
      },
      border: Boolean,
      multiple: Boolean,
      defaultText: {
        default: '请选择'
      },
      placeholder: {
        default: '请输入关键字',
        type: String
      },
      trigger: {
        default: 'click',
        type: String
      },
      showSearch: {
        default: false,
        type: Boolean
      },
      props: {
        default () {
          return {
            label: 'label',
            value: 'value'
          }
        }
      },
      data: {
        default: () => {},
        type: Object
      },
      remoteMethod: Function
    },
    data () {
      return {
        secondData: [],
        originOption: _.cloneDeep(this.options),
        originData: this.value,
        option: this.options || [],
        result: this.multiple ? _.cloneDeep(this.value) : this.value,
        labels: this.multiple ? [] : '',
        kw: ''
      }
    },
    computed: {
      getTitle () {
        let list = _.chain(this.secondData).filter(item => item.select).map(item => item.label).value()
        return list.length !== 0 ? list.join(',') : '请选择'
      },
      getOption () {
        return this.option
      }
    },
    async mounted () {
      if (this.remoteMethod) {
        this.option = await this.remoteMethod()
      }else {
        this.option = this.options;
      }
    },
    watch: {
      options: function (val) {
        if (!this.remoteMethod) {
          this.option = val
        }
      },
      value: {
        handler (val) {
          /*if (!Array.isArray(val)) {
            throw new Error('value should be Array')
          }
          this.option = this.getViews(val, this.option)*/
        },
        deep: true
      },
      secondData: {
        handler (val) {
          let list = _.map(val, item => item.value)
          this.$emit('input', list)
        },
        immediate: true
      }
    },
    methods: {
      getItem (data) {
        this.secondData = data.children
        this.option = _.map(this.option, item => {
          item.select = item.value === data.value;
          return item
        })
        this.secondData = _.map(this.secondData, item => _.assign(item, {select: true}))
      },
      changeChild (data) {
        this.secondData = _.map(this.secondData, item => {
          item.value === data.value && (item.select = !data.select);
          return item
        })
      },
      toggleItem (data, e) {
        if (!data.select) {
          this.option = _.map(this.option, item => {
            if (item.value === data.value) {
              item.select = false
            }
            return item
          })
          this.secondData = _.map(this.secondData, item => _.assign(item, {select: false}))
          event.preventDefault()
        } else {
          this.getItem(data)
        }
      },
      getViews (data, list) {
        let arr = []
        _.each(data, item => {
          arr = _.each(list, val => {
            if (item === val.value) {
              val.select = true
            } else if (val.children) {
              val.children = this.getViews(data, val.children)
            }
          })
        })
        return arr
      },
      changeValues (item) {
        this.getValues(item);
        this.changeStatus(item);
        !this.multiple && this.$emit('input', this.result);
      },
      confirm (type) {
        if (type === 1) {
          this.setValues();
        } else {
          this.setOrigin();
        }
        this.$emit('input', _.cloneDeep(this.result));
        this.$refs.dropdown.hide()
      },
      setValues () {
        this.originOption = _.cloneDeep(this.option);
        this.originData = _.cloneDeep(this.result);
      },
      setOrigin () {
        this.option = _.cloneDeep(this.originOption);
        this.result = _.cloneDeep(this.originData);
        this.changeStatus()
      },
      changeShow (type) {
        if (!type && this.multiple) {
          this.confirm(0)
        }
      },
      getValues (item) {
        let val = _.cloneDeep(item[this.props.value]);
        if (!this.multiple) {
          this.result = val;
        } else {
          let index = _.findIndex(this.result, item => item === val);
          if (index === -1) {
            this.result.push(val);
          } else {
            this.result.splice(index, 1);
          }
        }
      },
      changeStatus () {
        if (!this.multiple) {
          this.option = _.map(this.option, item => {
            return item[this.props.value] === this.result ? _.assign(item, {select: true}) : _.assign(item, {select: false})
          })
        } else {
          this.option = _.map(this.option, item => {
            let index = _.findIndex(this.result, val => item[this.props.value] === val);
            return index !== -1 ? _.assign(item, {select: true}) : _.assign(item, {select: false});
          })
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .row {
    display: flex;
  }
  .flex {
    display: flex;
    align-items: center;
    &:hover .unselected {
      border-color: #66b1ff;
    }
  }
  .first ,.second{
    width: 50%;
    padding: 0px 15px;
  }
  .first .flex {
    justify-content: space-between;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .second .flex {
    margin-bottom: 10px
  }
  .first:not(:last-child) {
    border-right: 1px solid #eee;
  }
  .unselected {
    width: 14px;
    height: 14px;
    margin-right:10px;
    border: 1px solid #d5d8de;
    border-radius: 2px;
    display: inline-block;
  }
  .line {
    height: 1px;
    margin: 10px auto;
    background-color: #D8D8D8;
  }
  .el-dropdown-link {
    cursor: pointer;
  }
  .el-dropdown-link:not([class*='border']) {
    font-weight: 600;
    .el-icon-arrow-down {
      font-weight: 600;
    }
  }
  .dropdown {
    min-width: 140px;
  }
  .dropdown li.el-dropdown-menu__item.actives {
    background-color: #ecf5ff;
    color: #66b1ff;
  }
  .searchBtns {
    display: flex;
    justify-content: center;
  }
  .dropdown ::v-deep  .el-dropdown-menu__item:focus:not(.actives) {
    background: #fff;
    color: #606266;
  }
  .border {
    border: 1px solid #dcdfe6;
    background: #fff;
    border-radius: 4px;
    padding: 0 15px;
    display: flex;
    align-items: center;
    line-height: 36px;
    width: 100%;
    justify-content: space-between;
  }
  .bordered.dropdown {
    width: 500px;
  }
</style>
